import ClientOAuth2 from "client-oauth2";

if (process && process.env.NODE_ENV === "test") {
  var url_to_auth = "http://id.gataene.local";
  window.lexConfig = {
    url_to_app: "http://api.gataene.local/v1",
    url_to_auth: url_to_auth,
    auth_client_id: 2,
    auth_access_token_uri: url_to_auth + "/oauth/token",
    auth_authorization_uri: url_to_auth + "/oauth/authorize",
    auth_redirect_uri: "http://app.gataene.local/login",
    auth_scopes: "*"
  };
}

const OAuth = new ClientOAuth2({
  clientId: window.lexConfig.auth_client_id,
  accessTokenUri: window.lexConfig.auth_access_token_uri,
  authorizationUri: window.lexConfig.auth_authorization_uri,
  redirectUri: window.lexConfig.auth_redirect_uri,
  scopes: window.lexConfig.auth_scopes
});
export default OAuth;
